import { getAppFeatureProp } from "@/utilities/app-feature-util";
import { get } from "lodash";

export const SUBSCRIPTION_SERVICE_TYPES = {
  SECRETARY: "secretary",
  NOMINEE_DIRECTOR: "director",
  NOMINEE_DIRECTOR_3: "nominee-director-03",
  NOMINEE_DIRECTOR_6: "nominee-director-06",
  NOMINEE_DIRECTOR_12: "nominee-director-12",
  MAILROOM: "mailroom",
  ACCOUNTING_SLIM: "accounting_slim",
  ACCOUNTING_STARTUP: "accounting_startup",
  ACCOUNTING_SME: "accounting_sme",
  ACCOUNTING_SUPREME: "accounting_supreme",
  CORP_SEC_1_SHAREHOLDER: "corp-sec-1-shareholder",
  CORP_SEC_2_SHAREHOLDER: "corp-sec-2-shareholder",
  CORP_SEC_3_5_SHAREHOLDER: "corp-sec-3-to-5-shareholder",
  CORP_SEC_6_9_SHAREHOLDER: "corp-sec-6-to-9-shareholder",
  CORP_SEC_10_20_SHAREHOLDER: "corp-sec-10-to-20-shareholder",
  CORP_SEC_21_30_SHAREHOLDER: "corp-sec-21-to-30-shareholder",
  CORP_SEC_31_50_SHAREHOLDER: "corp-sec-31-to-50-shareholder",
  ACCT_2_500_EXPENSE_ACCOUNTING_PLAN: "2_500_expense_accounting_plan",
  ACCT_7_500_EXPENSE_ACCOUNTING_PLAN: "7_500_expense_accounting_plan",
  ACCT_15_000_EXPENSE_ACCOUNTING_PLAN: "15_000_expense_accounting_plan",
  ACCT_35_000_EXPENSE_ACCOUNTING_PLAN: "35_000_expense_accounting_plan",
  ACCT_50_000_EXPENSE_ACCOUNTING_PLAN: "50_000_expense_accounting_plan",
  ACCT_75_000_EXPENSE_ACCOUNTING_PLAN: "75_000_expense_accounting_plan",
  ACCT_125_000_EXPENSE_ACCOUNTING_PLAN: "125_000_expense_accounting_plan",
  ACCT_175_000_EXPENSE_ACCOUNTING_PLAN: "175_000_expense_accounting_plan",
  ACCT_250_000_EXPENSE_ACCOUNTING_PLAN: "250_000_expense_accounting_plan",
  ACCT_325_000_EXPENSE_ACCOUNTING_PLAN: "325_000_expense_accounting_plan",
  ACCT_2_500_EXPENSE_PLAN: "2_500_expense_plan",
  ACCT_7_500_EXPENSE_PLAN: "7_500_expense_plan",
  ACCT_15_000_EXPENSE_PLAN: "15_000_expense_plan",
  ACCT_35_000_EXPENSE_PLAN: "35_000_expense_plan",
  ACCT_50_000_EXPENSE_PLAN: "50_000_expense_plan",
  ACCT_75_000_EXPENSE_PLAN: "75_000_expense_plan",
  ACCT_100_000_EXPENSE_PLAN: "100_000_expense_plan",
  ACCT_125_000_EXPENSE_PLAN: "125_000_expense_plan",
  ACCT_175_000_EXPENSE_PLAN: "175_000_expense_plan",
  ACCT_200_000_EXPENSE_PLAN: "200_000_expense_plan",
  ACCT_250_000_EXPENSE_PLAN: "250_000_expense_plan",
  ACCT_325_000_EXPENSE_PLAN: "325_000_expense_plan",
  ACCT_400_000_EXPENSE_PLAN: "400_000_expense_plan",
  ACCT_15_000_AUDIT_PLAN: "audit_plan_-_up_to_hkd_15k_monthly_expenses",
  ACCT_50_000_AUDIT_PLAN: "audit_plan_-_up_to_hkd_50k_monthly_expenses",
  ACCT_100_000_AUDIT_PLAN: "audit_plan_-_up_to_hkd_100k_monthly_expenses",
  ACCT_200_000_AUDIT_PLAN: "audit_plan_-_up_to_hkd_200k_monthly_expenses",
  ACCT_400_000_AUDIT_PLAN: "audit_plan_-_up_to_hkd_400k_monthly_expenses",
  ACCT_700_000_AUDIT_PLAN: "audit_plan_-_up_to_hkd_700k_monthly_expenses",
  AUDIT_PLAN: "audit_plan",
  ANNUAL_FILLING_BOOKKEEPING: "annual_filling_bookkeeping",
  ACCOUNTING_PAYROLL: "accounting_payroll",
  ACCOUNTING_PREMIUM: "accounting_premium",
  GST_ANNUAL_COMPLIANCE: "GST_annual_compliance",
  ACCOUNTING_XBRL_FILE: "accounting_XBRL_File",
  XERO_MULTI_CURRENCY_UPGRADE: "xero_multi_currency_upgrade",
  DORMANT_COMPANY: "dormant_company",
  PAYROLL_PER_STAFF: "payroll_per_staff",
  GST_QUARTERLY_COMPLIANCE: "GST_quarterly_compliance",
  SUPREME_QUARTERLY_PLAN: "supreme_quarterly_plan",
  SUPREME_PLUS_PLAN: "supreme_plus_plan",
  A2X_SHOPIFY_MINI: "A2X_shopify_-_mini",
  A2X_SHOPIFY_BASIC: "A2X_shopify_-_basic",
  A2X_SHOPIFY_STANDARD: "A2X_shopify_-_standard",
  A2X_SHOPIFY_ADVANCED: "A2X_shopify_-_advanced",
  A2X_AMAZON_MINI: "A2X_amazon_-_mini",
  A2X_AMAZON_BASIC: "A2X_amazon_-_basic",
  A2X_AMAZON_STANDARD: "A2X_amazon_-_standard",
  A2X_AMAZON_PREMIUM: "A2X_amazon_-_premium",
  ACRA_ANNUAL_FILING_FEE: "acra_annual_filing_fee",
  ANNUAL_BUSINESS_REGISTRATION_FEE_TO_HKSAR: "annual_business_registration_fee_to_hksar",
  TAX_RETURN_ONLY: "tax_return_only",
  ACCOUNTING_AND_TAX: "accounting_and_tax",
  UP_TO_250_000_YEARLY_ACCOUNTING_AND_TAX: "250_000_expense_accounting_tax_yearly",
  DEFAULT_ACCOUNTING_OPTION: "75_000_expense_accounting_tax_yearly",
  UP_TO_75_000_YEARLY_SOLE_TRADER_TAX_AND_ACCOUNTING: "75_000_expense_sole_trader_tax_return_yearly",
  DEFAULT_ACCOUNTING_OPTION_SERVICE_NAME: "accounting_and_tax",
  DEFAULT_ACCOUNTING_OPTION_SERVICE_NAME_SOLE_TRADER: "sole_trader_tax_return",
  dormant_company_compliance_yearly: "dormant_company_compliance_yearly",
  "75_000_expense_tax_return_only_yearly": "75_000_expense_tax_return_only_yearly",
  "250_000_expense_tax_return_only_yearly": "250_000_expense_tax_return_only_yearly",
  "500_000_expense_tax_return_only_yearly": "500_000_expense_tax_return_only_yearly",
  "2_000_000_expense_tax_return_only_yearly": "2_000_000_expense_tax_return_only_yearly",
  "75_000_expense_accounting_tax_yearly": "75_000_expense_accounting_tax_yearly",
  "250_000_expense_accounting_tax_yearly": "250_000_expense_accounting_tax_yearly",
  "500_000_expense_accounting_tax_yearly": "500_000_expense_accounting_tax_yearly",
  "2_000_000_expense_accounting_tax_yearly": "2_000_000_expense_accounting_tax_yearly",
  "75_000_expense_accounting_tax_payroll_yearly": "75_000_expense_accounting_tax_payroll_yearly",
  "250_000_expense_accounting_tax_payroll_yearly": "250_000_expense_accounting_tax_payroll_yearly",
  "500_000_expense_accounting_tax_payroll_yearly": "500_000_expense_accounting_tax_payroll_yearly",
  "2_000_000_expense_accounting_tax_payroll_yearly": "2_000_000_expense_accounting_tax_payroll_yearly",
  "75_000_expense_accounting_tax_monthly": "75_000_expense_accounting_tax_monthly",
  "250_000_expense_accounting_tax_monthly": "250_000_expense_accounting_tax_monthly",
  "500_000_expense_accounting_tax_monthly": "500_000_expense_accounting_tax_monthly",
  "2_000_000_expense_accounting_tax_monthly": "2_000_000_expense_accounting_tax_monthly",
  "75_000_expense_accounting_tax_payroll_monthly": "75_000_expense_accounting_tax_payroll_monthly",
  "250_000_expense_accounting_tax_payroll_monthly": "250_000_expense_accounting_tax_payroll_monthly",
  "500_000_expense_accounting_tax_payroll_monthly": "500_000_expense_accounting_tax_payroll_monthly",
  "2_000_000_expense_accounting_tax_payroll_monthly": "2_000_000_expense_accounting_tax_payroll_monthly",
  "75_000_expense_individual_tax_return_yearly": "75_000_expense_individual_tax_return_yearly",
  "75_000_expense_sole_trader_tax_return_yearly": "75_000_expense_sole_trader_tax_return_yearly",
  "75_000_expense_sole_trader_accounting_tax_yearly": "75_000_expense_sole_trader_accounting_tax_yearly",
  "250_000_expense_sole_trader_accounting_tax_yearly": "250_000_expense_sole_trader_accounting_tax_yearly",
  "500_000_expense_sole_trader_accounting_tax_yearly": "500_000_expense_sole_trader_accounting_tax_yearly",
  "75_000_expense_sole_trader_accounting_tax_monthly": "75_000_expense_sole_trader_accounting_tax_monthly",
  "250_000_expense_sole_trader_accounting_tax_monthly": "250_000_expense_sole_trader_accounting_tax_monthly",
  "500_000_expense_sole_trader_accounting_tax_monthly": "500_000_expense_sole_trader_accounting_tax_monthly",
  enterprise_adhoc_0_yearly: "enterprise_adhoc_0_yearly",
  enterprise_adhoc_1_yearly: "enterprise_adhoc_1_yearly",
  enterprise_adhoc_0_monthly: "enterprise_adhoc_0_monthly",
  enterprise_adhoc_1_monthly: "enterprise_adhoc_1_monthly",
  add_on_xero_multi_currency_yearly: "add_on_xero_multi_currency_yearly",
  add_on_individual_tax_return_yearly: "add_on_individual_tax_return_yearly",
  add_on_tax_planning_with_a_senior_tax_agent: "add_on_tax_planning_with_a_senior_tax_agent",
  add_on_rental_property_yearly: "add_on_rental_property_yearly",
  add_on_crypto_tax_return_yearly: "add_on_crypto_tax_return_yearly",
  add_on_cgt_event_yearly: "add_on_cgt_event_yearly",
  add_on_registered_address_virtual_mailroom_yearly: "add_on_registered_address_virtual_mailroom_yearly",
  add_on_monthly_activity_statement_yearly: "add_on_monthly_activity_statement_yearly",
  add_on_additional_payroll_seat_yearly: "add_on_additional_payroll_seat_yearly",
  add_on_monthly_activity_statement_monthly: "add_on_monthly_activity_statement_monthly",
  add_on_additional_payroll_seat_monthly: "add_on_additional_payroll_seat_monthly",
  "75_000_add_on_monthly_bookkeeping_yearly": "75_000_add_on_monthly_bookkeeping_yearly",
  "250_000_add_on_monthly_bookkeeping_yearly": "250_000_add_on_monthly_bookkeeping_yearly",
  "500_000_add_on_monthly_bookkeeping_yearly": "500_000_add_on_monthly_bookkeeping_yearly",
  "2_000_000_add_on_monthly_bookkeeping_yearly": "2_000_000_add_on_monthly_bookkeeping_yearly",
  ADD_ON_MONTHLY_BOOKKEEPING_YEARLY: "add_on_monthly_bookkeeping_yearly",
  EXPENSE_ACCOUNTING_TYPE_YEARLY: "expense_accounting_tax_yearly",
};

export const accountingSubsWithXeroSoftware = [
  // Accounting Filing & Bookkeeping
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_35_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ANNUAL_FILLING_BOOKKEEPING
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_75_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ANNUAL_FILLING_BOOKKEEPING
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_200_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ANNUAL_FILLING_BOOKKEEPING
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_400_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ANNUAL_FILLING_BOOKKEEPING
  }_plan`,

  // Accounting & Payroll
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_35_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PAYROLL
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_75_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PAYROLL
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_200_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PAYROLL
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_400_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PAYROLL
  }_plan`,

  // Accounting Premium
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_2_500_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PREMIUM
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_7_500_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PREMIUM
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_15_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PREMIUM
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_35_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PREMIUM
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_50_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PREMIUM
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_75_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PREMIUM
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_100_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PREMIUM
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_200_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PREMIUM
  }_plan`,
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_400_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PREMIUM
  }_plan`,

  // 75k above values
  `none_${SUBSCRIPTION_SERVICE_TYPES.ANNUAL_FILLING_BOOKKEEPING}_plan`,
  `none_${SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PAYROLL}_plan`,
  `none_${SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PREMIUM}_plan`,
];

export const accountingSubsWithXbrl = [
  // Accounting Filing & Bookkeeping
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_75_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ANNUAL_FILLING_BOOKKEEPING
  }_plan`,
  // Accounting & Payroll
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_75_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PAYROLL
  }_plan`,
  // Accounting Premium
  `${SUBSCRIPTION_SERVICE_TYPES.ACCT_75_000_EXPENSE_PLAN.replace("_plan", "")}_${
    SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PREMIUM
  }_plan`,
];

export const getAccountingPlanService = (service, accountingPlan) => {
  return `${accountingPlan.replace("_plan", "")}_${service}_plan`; //Convention: 50_000_expense_accounting_premium_plan
};

export const nameOfAccountingOption = {
  [SUBSCRIPTION_SERVICE_TYPES.ANNUAL_FILLING_BOOKKEEPING]: "Annual Bookkeeping",
  [SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PAYROLL]: "Accounting Payroll",
  [SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PREMIUM]: "Accounting Premium",
};

export const textValuesOfAccountingOption = {
  [SUBSCRIPTION_SERVICE_TYPES.ANNUAL_FILLING_BOOKKEEPING]: "Annual Filing & Bookkeeping",
  [SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PAYROLL]: "Accounting and Payroll",
  [SUBSCRIPTION_SERVICE_TYPES.ACCOUNTING_PREMIUM]: "Accounting Premium",
};

export const textValueOfAccountingExpense = {
  [SUBSCRIPTION_SERVICE_TYPES.ACCT_2_500_EXPENSE_PLAN]: "Up to 2500",
  [SUBSCRIPTION_SERVICE_TYPES.ACCT_7_500_EXPENSE_PLAN]: "Up to 7500",
  [SUBSCRIPTION_SERVICE_TYPES.ACCT_15_000_EXPENSE_PLAN]: "Up to 15000",
  [SUBSCRIPTION_SERVICE_TYPES.ACCT_35_000_EXPENSE_PLAN]: "Up to 35000",
  [SUBSCRIPTION_SERVICE_TYPES.ACCT_75_000_EXPENSE_PLAN]: "Up to 75000",
  ["none"]: "More than 75000",
};

// eslint-disable-next-line max-lines-per-function
export const getAccountingPlans = (
  component,
  option = { isIncludedNoneValue: true, isNewAccountingUI: false, isSubscriptionsTransfer: false, isCompany: true }
) => {
  const { isIncludedNoneValue, isNewAccountingUI, isSubscriptionsTransfer, isCompany } = option;
  const customerSubscriptions = getAppFeatureProp(
    component.platformConfig.cmsAppFeatures,
    isSubscriptionsTransfer ? "subscriptions_transfer" : "subscriptions"
  );

  if (component.isNewAccountingUI || isNewAccountingUI) {
    if (isSubscriptionsTransfer) {
      const newAccountingServicesTransfer = getAppFeatureProp(customerSubscriptions.props, "new_accounting_services");
      const activeCompanyAccountingServices = getAppFeatureProp(
        newAccountingServicesTransfer.props,
        "active_company_accounting_services"
      );
      const soleTraderAccountingServices = getAppFeatureProp(
        newAccountingServicesTransfer.props,
        "sole_trader_accounting_services"
      );

      const activeCompanyAccountingPlans = get(activeCompanyAccountingServices, "value.accounting_plans", []);
      const soleTraderAccountingPlans = get(soleTraderAccountingServices, "value.accounting_plans", []);

      const newServices = isCompany ? activeCompanyAccountingPlans : soleTraderAccountingPlans;

      return newServices;
    } else {
      const newAccountingServices = getAppFeatureProp(customerSubscriptions.props, "new_accounting_services");
      const newServices = get(newAccountingServices, "value.accounting_plans", []);
      return newServices;
    }
  } else {
    const new_accounting_packages = getAppFeatureProp(customerSubscriptions.props, "new_accounting_packages");
    const zh_new_accounting_packages = getAppFeatureProp(customerSubscriptions.props, "zh_accounting_packages");
    const enValue = get(new_accounting_packages, "value", []);
    const zhValue = get(zh_new_accounting_packages, "value", []);
    return {
      enVal: isIncludedNoneValue ? enValue : enValue.filter((item) => item.service !== "none"),
      zhVal: isIncludedNoneValue ? zhValue : zhValue.filter((item) => item.service !== "none"),
    };
  }
};
